<template>
  <div class="app-container">
    <el-form :model="search" :inline="true" label-position="right" ref="search">
      <el-form-item label="归集区域(省)" prop="provinceCode">
        <el-select
          v-model="search.provinceCode"
          placeholder="请选择"
          clearable
          style="width: 100%"
          @change="getTblCity"
        >
          <el-option
            v-for="item in provinceList"
            :key="item.provinceCode"
            :label="item.provinceName"
            :value="item.provinceCode"
            style="width: 100%"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="归集区域(市)" prop="cityCode">
        <el-select
          v-model="search.cityCode"
          placeholder="请选择"
          clearable
          style="width: 100%"
          :disabled="!search.provinceCode"
        >
          <el-option
            v-for="item in cityList"
            :key="item.cityCode"
            :label="item.cityName"
            :value="item.cityCode"
            style="width: 100%"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否分配归集仓" prop="isAllocate">
        <el-select
          v-model="search.isAllocate"
          placeholder="请选择"
          clearable
          style="width: 100%"
        >
          <el-option
            v-for="(val, key) in isAllocateOPtion"
            :key="key"
            :label="val"
            :value="key"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="归集仓名称" prop="warehouseName">
        <el-input
          v-model="search.warehouseName"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="归集仓编号" prop="warehouseNo">
        <el-input
          v-model="search.warehouseNo"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="row-bg">
      <el-button type="primary" size="medium" @click="batchAddFun"
        >批量分配归集仓</el-button
      >
      <el-button type="primary" size="medium" @click="exportExcel()"
        >导出</el-button
      >
      <el-button type="primary" size="medium" @click="handleSearch()"
        >查询</el-button
      >
      <el-button size="medium" @click="resetForm">重置</el-button>
    </div>
    <el-table
      ref="checktableData"
      :data="list"
      v-loading="listLoading"
      :reserve-selection="true"
      center
      height="60vh"
    >
      <el-table-column
        label="归集区域(省)"
        prop="provinceName"
        width="200"
      ></el-table-column>
      <el-table-column
        label="归集区域(市)"
        prop="cityName"
        width="200"
      ></el-table-column>
      <el-table-column label="是否分配归集仓" prop="isAllocate" width="120">
        <!-- <template slot-scope="scope">{{
          scope.row.isAllocate === 0
            ? "已分配"
            : scope.row.isAllocate === 1
            ? "未分配"
            : "--"
        }}</template> -->
      </el-table-column>
      <el-table-column
        label="归集仓名称"
        prop="warehouseName"
      ></el-table-column>
      <el-table-column label="归集仓编码" prop="warehouseNo"></el-table-column>
      <el-table-column label="是否WMS仓库" prop="wmsWarehouse" width="150">
        <template slot-scope="scope">{{
          scope.row.wmsWarehouse === 0
            ? "是"
            : scope.row.wmsWarehouse === 1
            ? "否"
            : "--"
        }}</template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="200" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="setWarehouse(scope.row)"
            >分配</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="search.currPage"
        :page-size="search.pageSize"
        :page-sizes="[10, 20]"
        :total="total"
      >
      </el-pagination>
    </div>
    <setWarehouserDialog
      ref="setWarehouseRef"
      @opera-success="getList"
    ></setWarehouserDialog>
    <commonBath
      ref="batchCommonRef"
      @opera-success="getList"
      :errUrl="'/autoapp-default-server-recovery/api/warehouse/downLoadAllocateFailInfo'"
      :downloadTemplateUrl="'/autoapp-default-server-recovery/api/warehouse/exportWarehouseAllocate'"
      :importUrl="'/autoapp-default-server-recovery/api/warehouse/importWarehouseAllocate'"
      :title="'批量分配归集仓'"
      :uploadTitle="'导入归集仓分配'"
    ></commonBath>
  </div>
</template>
<script>
import { findAllProvince, findAllCity } from "@/api/oldForNew";
import { findWarehouseAllocate } from "@/api/wareHouse";

import setWarehouserDialog from "./components/setWarehouseDialog";
import commonBath from "./components/commonBath.vue";

export default {
  name: "warehouseArea",
  components: {
    setWarehouserDialog,
    commonBath,
    // BatchSetWarehouseArea,
  },
  filters: {},
  data() {
    return {
      list: [],
      total: null, //列表总条数
      listLoading: false,
      provinceList: [], //省份列表
      cityList: [], //市列表
      isAllocateOPtion: { 0: "已分配", 1: "未分配" },
      search: {
        provinceCode: "",
        cityCode: "",
        warehouseNo: "",
        warehouseName: "",
        isAllocate: "",
        currPage: 1, //当前页
        pageSize: 10,
      },
    };
  },
  async created() {
    this.getTblProvince();
    this.getList();
  },
  methods: {
    handleSearch() {
      this.search.currPage = 1;
      this.getList();
    },
    async getList() {
      let { data, statusCode, total } = await findWarehouseAllocate(
        this.search
      );
      if (statusCode == 200) {
        this.list = data;
        this.total = total;
      }
    },
    resetForm() {
      this.search = this.$options.data().search;
    },

    handleSizeChange(val) {
      this.search.currPage = 1;
      this.search.pageSize = val;
      this.getList();
    },
    handleCurrentChange() {
      this.getList();
    },
    //获取省份列表
    async getTblProvince() {
      this.search.cityCode = "";
      let { statusCode, data } = await findAllProvince();
      if (statusCode === 200) {
        this.provinceList = data;
      }
    },
    //根据省份获取城市列表
    async getTblCity() {
      this.search.cityCode = "";
      if (!this.search.provinceCode) {
        return;
      }
      let { statusCode, data } = await findAllCity(this.search.provinceCode);
      if (statusCode === 200) {
        this.cityList = data;
      }
    },

    //批量分配归集仓
    batchAddFun() {
      this.$refs.batchCommonRef.openDialog();
    },
    //提交回收单
    setWarehouse(row) {
      this.$refs.setWarehouseRef.openDialog(row);
    },
    //导出
    exportExcel() {

      let url = `/autoapp-default-server-recovery/api/warehouse/exportWarehouseAllocate`;
      this.HttpService.post(url, {}).then(res => {
        if (res.statusCode == 200) {
          this.$message.success('正在导出, 稍后请到下载中心查看')
        } else {
          this.$message.warning(res.message)
        }
      })
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.goodsStyle {
  display: flex;
  align-items: center;
}
.flex {
  display: flex;
  align-items: center;
  // margin: 0 20px;
  padding: 0 20px;
  span {
    min-width: 100px;
  }
}
.row-bg {
  margin-bottom: 15px;
}
.btnBox {
  margin-bottom: 20px;
}
.data-view-wrap {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-start;
  .item-wrap {
    margin-right: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #00b882;
    padding: 10px;
    height: auto;
    color: #fff;

    .unit {
      margin-left: 20px;
      max-width: 300px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      > span {
        font-size: 20px;
        padding-right: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldForNewService/warehouseArea.vue